<script>
	import { createEventDispatcher } from "svelte";

	export let onClick = () => {};
	export let selected = false;
	export let className = "";
	export let onKeyDown = () => {};

	const dispatch = createEventDispatcher();
</script>

<span
	class={"text-center sample cursor pointer " + className}
	class:selected
	on:click={() => {
		onClick();
		dispatch("click");
	}}
	on:keydown={(e) => {
		onKeyDown(e);
		dispatch("keydown", e);
	}}
	style:selected={selected ? "border: 3px solid red;" : ""}
>
	Watch Video
</span>

<style>
	.pointer {
		cursor: pointer;
	}
</style>
